// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"clinical-portal-3__HeaderLogo__headerLogo","logoLink":"clinical-portal-3__HeaderLogo__logoLink","image":"clinical-portal-3__HeaderLogo__image"};